import { v4 as uuid } from 'uuid';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showAddressDialog = ({
  addressId = null,
  requestId = uuid(),
  closeOnSave = false,
  copyFromAddressId = null,
} = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_ADDRESS_DIALOG,
  payload: { addressId, requestId, closeOnSave, copyFromAddressId },
});

export const hideAddressDialog = (requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_ADDRESS_DIALOG,
  payload: { requestId },
});

export const addressDialogSaved = (address, requestId, isEditMode) => ({
  type: USER_DIALOG_ACTION_TYPES.ADDRESS_DIALOG_SAVED,
  payload: { address, requestId, isEditMode },
});

export const addressDialogDeleted = (addressId, requestId) => ({
  type: USER_DIALOG_ACTION_TYPES.ADDRESS_DIALOG_DELETED,
  payload: { addressId, requestId },
});
